module.exports = __webpack_public_path__ + "img/icone_icone_5.225ec8f6.svg";